import React from 'react';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { dateFormatForDatePicker } from '../../../../../SharedModules/CommonConstants/commonConstants';
import { validDate } from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { isReadOnly as readOnly } from '../../../../../SharedModules/utilities/utilities';
import { setErrorMessages, setGridData } from '../../Store/actions';
import {
  compareTwoDatesGreaterThanOrEqual,
  formatToCorrectDate,
} from '../../../../../SharedModules/DateUtilities/DateUtilities';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';

export default (props) => {
  const { column, data, node, rowIndex, isEnablebyRole } = props;
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly =
      readOnly(window.location.pathname, loginState)?.readOnly || false;
  }
  const dispatch = useDispatch();
  const gridData = useSelector((state) => {
    return state.sharedState.IneligibleProvidersReducer.gridData;
  });
  const errorMessagesFromRedux = useSelector((state) => {
    return state.sharedState.IneligibleProvidersReducer.errorMessagesInRedux;
  });
  let rowIndexId = 0;
  if (gridData && gridData.length > 0) {
    rowIndexId = gridData.findIndex((x) => {
      return x.tempId === props.data.tempId;
    });
  }
  // handing on change date event
  const handleOnChangeDateFields = (d, name) => {
    let localErr = errorMessagesFromRedux || [];

    const newObj = [...gridData];
    if (d !== 'Invalid Date') {
      newObj[rowIndexId][column.colId] = d;
      if (column.colId === 'ineligProviderBeginDt') {
        props.node.setDataValue('ineligProviderBeginDt', d);
        newObj[rowIndexId].ineligProviderBeginDt = d;
        newObj[rowIndexId].ineligProviderBeginDtErr = false;
        newObj[rowIndexId].isUpdateIneligProviderBeginDt = true;
      }
      if (column.colId === 'endDt') {
        newObj[rowIndexId].endDt = d;
        newObj[rowIndexId].endDtErr = false;
        newObj[rowIndexId].isUpdateEndDt = true;

        props.node.setDataValue('endDt', d);
      }
      newObj[rowIndexId].addEditRow = true;
      localErr = localErr?.filter(
        (item) =>
          item.fieldName !== `${column.colId}${rowIndex}` &&
          item.errorType !== ('InvalidDate' || 'compareDateGreater')
      );
      dispatch(setGridData(newObj));
      dispatch(setErrorMessages([...new Set(localErr)]));
    }
  };
  const handleChangeDate = (d) => {
    let localErr = errorMessagesFromRedux || [];
    const newObj = [...gridData];

    const { colId } = column;

    if (d?.target?.value !== undefined) {
      newObj[rowIndexId].addEditRow = true;
      let { value } = d?.target;
      if (d.target?.value && d.target?.value.length > 5) {
        const data1 = d?.target.value?.split('/');
        if (data1[2]?.split('_')?.length === 3) {
          value = moment(d.target.value, 'MM/DD/YY').format('MM/DD/YYYY');
        } else {
          value =
            data1[2]?.split('_')?.length === 1 && data1[2]?.startsWith('00')
              ? formatToCorrectDate(d.target.value)
              : d.target.value;
        }
      }
      if (value && validDate(new Date(value)) === false) {
        props.node.setDataValue(colId, value);
        newObj[rowIndexId][colId] = value;
        if (colId === 'ineligProviderBeginDt') {
          newObj[rowIndexId].ineligProviderBeginDtErr = true;
        }
        if (colId === 'endDt') {
          newObj[rowIndexId].endDtErr = true;
        }
        dispatch(setGridData(newObj));
        localErr.push({
          fieldName: `${colId}${rowIndex}`,
          errorType: 'InvalidDate',
          message: `${
            constantMessageData.DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE
          } ${rowIndex + 1}.`,
        });
      } else if (colId === 'ineligProviderBeginDt') {
        if (value === '' || value === null) {
          node.setDataValue(colId, value);
          newObj[rowIndexId].ineligProviderBeginDt = value;
          newObj[rowIndexId].ineligProviderBeginDtErr = true;
          dispatch(setGridData(newObj));
          localErr = localErr?.filter(
            (item) =>
              item.fieldName !== `${colId}${rowIndex}` &&
              item.errorType !==
                ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
          );
          localErr.push({
            fieldName: `${colId}${rowIndex}`,
            errorType: 'dateRequired',
            message: `${
              constantMessageData.INEDIBILITY_PERIOD_BEGIN_DATE_REQ
            } ${rowIndex + 1}.`,
          });
        } else {
          if (
            data.endDt !== null &&
            data.endDt !== '' &&
            data.endDt !== 'Invalid date' &&
            compareTwoDatesGreaterThanOrEqual(
              new Date(data.endDt),
              moment(new Date(value))
            )
          ) {
            newObj[rowIndexId].endDtErr = true;
            localErr = localErr?.filter(
              (item) =>
                item.fieldName !== `${colId}${rowIndex}` &&
                item.errorType !==
                  ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
            );
            localErr.push({
              fieldName: `${colId}${rowIndex}`,
              errorType: 'compareDateGreater',
              tabName: 'CoverageGap',
              message: `${
                constantMessageData.INEDIBILITY_PERIOD_END_DATE_GREATER_THAN_INEDIBILITY_PERIOD_BEGIN_DATE_ERROR
              } ${rowIndex + 1}.`,
            });
          } else {
            newObj[rowIndexId].endDtErr = false;
            localErr = localErr?.filter(
              (item) =>
                item.fieldName !== `${colId}${rowIndex}` &&
                item.errorType !==
                  ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
            );
          }
          node.setDataValue(colId, value);
          newObj[rowIndexId].ineligProviderBeginDt = value;
          newObj[rowIndexId].isUpdateIneligProviderBeginDt = true;

          newObj[rowIndexId].ineligProviderBeginDtErr = false;
          dispatch(setGridData(newObj));
        }
      } else if (
        value !== null &&
        value !== '' &&
        validDate(new Date(value)) === false
      ) {
        node.setDataValue(colId, value);
        newObj[rowIndexId].D = value;
        newObj[rowIndexId].endDtErr = true;
        localErr = localErr?.filter(
          (item) =>
            item.fieldName !== `${colId}${rowIndex}` &&
            item.errorType !==
              ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
        );
        localErr.push({
          fieldName: `${colId}${rowIndex}`,
          errorType: 'compareDateGreater',
          tabName: 'CoverageGap',
          message: `${
            constantMessageData.INEDIBILITY_PERIOD_END_DATE_GREATER_THAN_INEDIBILITY_PERIOD_BEGIN_DATE_ERROR
          } ${rowIndex + 1}.`,
        });
        dispatch(setGridData(newObj));
      } else if (
        value !== null &&
        value !== '' &&
        compareTwoDatesGreaterThanOrEqual(
          new Date(value),
          moment(newObj[rowIndexId].ineligProviderBeginDt)
        )
      ) {
        node.setDataValue(colId, value);
        newObj[rowIndexId].endDt = value;
        newObj[rowIndexId].endDtErr = true;
        localErr = localErr?.filter(
          (item) =>
            item.fieldName !== `${colId}${rowIndex}` &&
            item.errorType !==
              ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
        );
        localErr.push({
          fieldName: `${colId}${rowIndex}`,
          errorType: 'compareDateGreater',
          tabName: 'CoverageGap',
          message: `${
            constantMessageData.INEDIBILITY_PERIOD_END_DATE_GREATER_THAN_INEDIBILITY_PERIOD_BEGIN_DATE_ERROR
          } ${rowIndex + 1}.`,
        });
        dispatch(setGridData(newObj));
      } else {
        localErr = localErr?.filter(
          (item) =>
            item.fieldName !== `${colId}${rowIndex}` &&
            item.errorType !==
              ('InvalidDate' || 'compareDateGreater' || 'dateRequired')
        );
        node.setDataValue(colId, value);
        newObj[rowIndexId].endDt = value;
        newObj[rowIndexId].isUpdateEndDt = true;
        newObj[rowIndexId].endDtErr = false;
        dispatch(setGridData(newObj));
      }
    }

    dispatch(setErrorMessages([...new Set(localErr)]));
  };

  return (
    <div data-testid='mfg-bankruptcy-date-picker' tabIndex="0">
      {column.colId === 'ineligProviderBeginDt' ? (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <label
            className='m-0 visually-hidden'
            htmlFor={`date_${column.colId}_${rowIndex}`}
          >
            <span>label</span>{' '}
          </label>
          <KeyboardDatePicker
            required
            id={`date_${column.colId}_${rowIndex}`}
            data-testid='start-date'
            label={false}
            mask='__/__/____'
            className={
              gridData &&
              gridData[rowIndexId] &&
              gridData[rowIndexId]?.ineligProviderBeginDtErr
                ? 'td-active-cell tBill-validate'
                : ''
            }
            InputLabelProps={{ shrink: true }}
            format={dateFormatForDatePicker}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            InputProps={{
              readOnly: false,
              autoFill: false,
            }}
            placeholder='mm/dd/yyyy'
            value={data?.ineligProviderBeginDt || null}
            onChange={(e) => {
              handleOnChangeDateFields(e, column.colId);
            }}
            onBlur={(e) => {
              handleChangeDate(e, 'onBlur');
            }}
            onKeyDown={async (e) => {
              if (e.keyCode == 67) {
                // copy date
                await window.navigator?.clipboard.writeText(e?.target?.value);
              }
            }}
            helperText={null}
            error
            disabled={isReadOnly || !isEnablebyRole}
          />
        </MuiPickersUtilsProvider>
      ) : (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <label
            className='m-0 visually-hidden'
            htmlFor={`date_${column.colId}_${rowIndex}`}
          >
            <span>label</span>{' '}
          </label>
          <KeyboardDatePicker
            id={`date_${column.colId}_${rowIndex}`}
            data-testid='end-date'
            label={false}
            format='MM/dd/yyyy'
            mask='__/__/____'
            className={
              gridData && gridData[rowIndexId] && gridData[rowIndexId]?.endDtErr
                ? 'td-active-cell tBill-validate'
                : ''
            }
            InputLabelProps={{
              shrink: true,
            }}
            placeholder='mm/dd/yyyy'
            value={data?.endDt || null}
            InputProps={{
              readOnly: false,
              autoFill: false,
            }}
            onChange={(e) => {
              handleOnChangeDateFields(e, column.colId);
            }}
            onBlur={(e) => {
              handleChangeDate(e, 'onBlur');
            }}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
            onKeyDown={async (e) => {
              if (e.keyCode == 67) {
                // copy date
                await window.navigator?.clipboard.writeText(e?.target?.value);
              }
            }}
            helperText={null}
            error
            disabled={isReadOnly || !isEnablebyRole}
          />
        </MuiPickersUtilsProvider>
      )}
    </div>
  );
};
